<template>
    <div class="w-full px-3 md:px-12 py-6">
      <div class="flex justify-between items-center mx-auto">
        <a href="/dashboard">
          <img :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}LogoHeader.svg`" alt="Logo" class="h-[40px]" />
        </a>
        <button
          class="bg-[#EBEBEB] text-[#000000] font-semibold rounded-full flex items-center gap-1 px-6 py-3 text-base focus:outline-none"
          @click="changeLang()">
          <i class="ri-earth-line text-xl"></i>
          {{ locale === "en" ? "Español" : "English" }}
        </button>
      </div>
    </div>
</template>

<script setup>
import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_LANDING_PATH } from "@/config/constants.js";

import { useI18n } from "vue-i18n";

const { locale } = useI18n();

const changeLang = () => {
  return (locale.value = locale.value === "en" ? "es" : "en");
};
</script>
